import { useEffect, useRef, forwardRef } from 'react'
import { DragOutlined } from '@ant-design/icons'

import { renderTranslation } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { marketplaceSectionContainer, marketplaceSectionId } from '../../../Constants/Configuration'
import MarketplaceAvailabilities from './MarketplaceAvailabilities'
import { useAppSelector } from '../../../hooks'

function MarketplaceAvailabilitiesGridLayout(
  { style, className, onMouseDown, onMouseUp, onTouchEnd, children, ...props },
  ref,
) {
  const language = useAppSelector(state => state.present.language.value)
  const articleSelected = useAppSelector(state => state.present.articleDetail.articleSelected)
  const isMarketplaceAvailabilitiesEnable = useAppSelector(
    state => state.present.configuration.isMarketplaceAvailabilitiesEnable,
  )
  const workspaceMarketplaceAvailabilitiesVisible = useAppSelector(
    state => state.present.configuration.workspaceMarketplaceAvailabilitiesVisible,
  )
  const marketplaceAvailabilitiesDatasource = useAppSelector(
    state => state.present.articleDetail.articleSelected.marketplaceAvailabilities,
  )
  const marketBoxDomElementRef = useRef(null)

  const isMarketplaceAvailabilitiesFetched = articleSelected.fetchedMarketplaceAvailabilities

  const isMarketplaceBoxVisible = isMarketplaceAvailabilitiesEnable && workspaceMarketplaceAvailabilitiesVisible

  const emptyClass = marketplaceAvailabilitiesDatasource?.length > 0 ? '' : ' emptyBar'

  useEffect(() => {
    const marketRef = marketBoxDomElementRef.current
    marketBoxDomElementRef && props.domElementsRefObserver && props.domElementsRefObserver.observe(marketRef)

    return () => {
      marketBoxDomElementRef && props.domElementsRefObserver && props.domElementsRefObserver.unobserve(marketRef)
    }
  }, [props.domElementsRefObserver, marketBoxDomElementRef])

  useEffect(() => {
    //essential for first render to match container width
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 500)
  }, [])

  return (
    <div
      id={marketplaceSectionId}
      grid-data={props.datagrid}
      className={className + (!isMarketplaceBoxVisible || !isMarketplaceAvailabilitiesFetched ? ' d-none' : '')}
      style={{ ...style }}
      ref={ref}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onTouchEnd={onTouchEnd}
    >
      <div className='grid-layout-adjust-wrapper'>
        <div className='drag-handle-grid-container'>
          <DragOutlined />
        </div>
        <div className='diwa-container' ref={marketBoxDomElementRef} id={marketplaceSectionContainer}>
          <div className={`label-drag${emptyClass}`}>
            {renderTranslation(language, TranslationKeys.buttonAvailabilitySection)}
          </div>
          <MarketplaceAvailabilities />
        </div>
      </div>
    </div>
  )
}

export default forwardRef(MarketplaceAvailabilitiesGridLayout)
